import { combineReducers } from 'redux';
import * as types from './types';
import initialState from './initialState';

type Action = { type: string; payload?: any };

const defaultAction = { type: '' };

const referralsReducer = (state = initialState, action: Action = defaultAction) => {
  switch (action.type) {
    case types.FETCH_REFERRALS_ELIGIBILITY_BEGIN:
    case types.FETCH_REFERRALS_ELIGIBILITY_SUCCESS:
    case types.FETCH_REFERRALS_ELIGIBILITY_ERROR:
      return state;

    case types.UPDATE_REFERRALS_DISPLAY_TOGGLE:
      return action.payload;
    default:
      return state;
  }
};

const reducer = combineReducers({
  referrals: referralsReducer
});

export default reducer;
